import Vue from 'vue';
import GeSvgHover from './ge-svg-hover';

// Main component
Vue.component('ge-svg-hover', GeSvgHover);

export default GeSvgHover;



// WEBPACK FOOTER //
// ./scripts/ge-svg-hover/index.js